<template>
  <v-flex fill fill-height horizontal>
    <div class="text-xs-center" v-if="loading">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-else class="header-section">
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs8>
            <h1>Season Management</h1>
          </v-flex>
          <v-flex xs4 text-xs-right>
            <v-btn dark small color="indigo" @click.stop="dialog = true">
              <v-icon dark>add</v-icon>
              New Season
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <section v-if="!loading" class="elevation-1">
      <v-data-table :headers="headers" :items="seasons" hide-actions>
        <template slot="items" slot-scope="props">
          <tr @click="edit(props.item)">
            <td>{{ props.item.season_id }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.track_hole_scores }}</td>
            <td>{{ props.item.win_bonus_points }}</td>
            <td>{{ props.item.weeks_for_points }}</td>
            <td>{{ props.item.weeks_for_average }}</td>
            <td>{{ props.item.start_date | dateOnly }}</td>
            <td>{{ props.item.end_date | dateOnly }}</td>
            <td>{{ props.item.active }}</td>
          </tr>
        </template>
      </v-data-table>
    </section>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          selectedSeason.id === -1 ? "New Season" : "Edit Season"
        }}</v-card-title>

        <v-card-text>
          <v-form>
            <v-container>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="selectedSeason.name"
                    :counter="50"
                    label="Name"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="true"
                    :nudge-right="10"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="selectedSeason.start_date"
                        label="Start Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      no-title
                      scrollable
                      v-model="selectedSeason.start_date"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6>
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="true"
                    :nudge-right="10"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="selectedSeason.end_date"
                        label="End Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      no-title
                      scrollable
                      v-model="selectedSeason.end_date"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="selectedSeason.win_bonus_points"
                    label="Bonus points for winning"
                    type="number"
                    min="0"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="selectedSeason.weeks_for_points"
                    label="Weeks for points"
                    type="number"
                    min="0"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="selectedSeason.weeks_for_average"
                    label="Weeks for Average"
                    type="number"
                    min="0"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                    v-model="selectedSeason.track_hole_scores"
                    label="Track hole scores"
                    :disabled="selectedSeason.season_id !== -1"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                    v-model="selectedSeason.active"
                    label="Active (show in stats site)"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" flat="flat" @click="resetForm()">
            Cancel
          </v-btn>

          <v-btn color="green darken-1" flat="flat" @click="saveSeason()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import VueSticky from "vue-sticky";

export default {
  name: "SeasonManagement",
  directives: {
    sticky: VueSticky,
  },
  data() {
    return {
      stickyConfig: {
        zIndex: 1,
        stickyTop: 64,
        disabled: false,
      },
      headers: [
        { text: "Id", value: "season_id" },
        { text: "Name", value: "name" },
        { text: "Track Holes Scores", value: "track_hole_scores" },
        { text: "Win Bonus", value: "win_bonus_points" },
        { text: "Weeks for Points", value: "weeks_for_points" },
        { text: "Weeks for Average", value: "weeks_for_average" },
        { text: "Start Date", value: "start_date" },
        { text: "End Date", value: "end_date" },
        { text: "Active", value: "active" },
      ],
      error: null,
      loading: false,
      dialog: false,
      seasons: [],
      selectedSeason: null,
      menu1: false,
      menu2: false,
    };
  },
  methods: {
    async init() {
      this.generateNewSeason();
      await this.fetchData();
    },
    async fetchData() {
      this.error = null;
      this.seasons = [];
      this.loading = true;
      try {
        const raw = await this.$apiClient.seasons();
        this.seasons = raw.data;
      } catch (e) {
        this.error = e;
      }

      this.loading = false;
    },
    generateNewSeason() {
      this.selectedSeason = {
        season_id: -1,
        name: null,
        win_bonus_points: null,
        weeks_for_points: null,
        weeks_for_average: null,
        start_date: null,
        end_date: null,
        track_hole_scores: false,
        active: true,
      };
      this.dialog = false;
    },
    async saveSeason() {
      if (this.selectedSeason.season_id === -1) {
        await this.$apiClient.createSeason(this.selectedSeason);
      } else {
        await this.$apiClient.updateSeason(this.selectedSeason);
      }

      this.init();
    },
    edit(item) {
      this.selectedSeason = Object.assign({}, item);
      this.dialog = true;
    },
    resetForm() {
      this.dialog = false;
      this.generateNewSeason();
    },
  },
  watch: {
    $route: "init",
    "$vuetify.breakpoint": "adjustOffset",
  },
  created() {
    this.init();
  },
};
</script>

<style scoped></style>
